<template>
	<section class="hero is-light-grey is-medium">
		<div class="hero-body">
			<div class="container has-text-centered">
				<p>
					<img src="@/assets/images/logo.png" height="40" alt="HT Auction logo" />
				</p>
				<h1 class="title">{{ $t('E404.Page not found') }}</h1>
				<div class="body">
					<p>
						{{ $t('E404.You could visit our') }}
						<router-link :to="{ path: '/' }">
							{{ $t('E404.frontpage') }}
						</router-link>
						{{ $t('E404.or check out') }}
						<router-link :to="{ name: 'Products' }"> {{ $t('E404.all our auctions') }}. </router-link>
					</p>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'E404',
	metaInfo: {
		title: '404',
		titleTemplate: '%s | htaukcio.com',
		meta: [
			{ name: 'robots', content: 'noindex' },
		]
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
